import React from 'react'
import { Tooltip } from '@mobi/component-library/Overlays/Tooltip'

export const ShareToBetLoopTooltip: React.FC<{
  triggerElRef: React.RefObject<HTMLElement | null>
  onDismissed(): void
}> = ({ triggerElRef, onDismissed }) => {
  return (
    <Tooltip
      color='blue'
      hasTooltipBeenSeen={() => false}
      shouldHideCrossIcon
      triggerElRef={triggerElRef}
      tooltipId='bet-loop-share-button'
      preferredPlacement='top'
      offsetYPx={8}
      offsetXPx={0}
      flipElement
      shouldOnlyRenderSingleInstance
      onDismissed={onDismissed}
    >
      <center>
        Share this Bet
        <br />
        to Bet Loop
      </center>
    </Tooltip>
  )
}
